import React, { useState } from "react";
import PostHooks from "../../../../Api/PostHooks";
import AlertComponent from "../../../../Components/AlertComponent";
import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useForm } from "react-hook-form";

const UserSmsForm = ({ user, onClose, onSuccess }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const [loading, response, request] = PostHooks();

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const onSubmit = async (e) => {
    try {
      let formData = {
        msisdn: user.msisdn,
        message: e.message,
      };

      let props = {
        url: "sms",
        body: formData,
      };
      const smsResp = await request(props);

      if (smsResp && smsResp.status === 200 && smsResp.data.StatusCode === 0) {
        setSnackbar({
          open: true,
          severity: "success",
          message: "sms sent successfully!",
        });

        setTimeout(() => {
          onSuccess();
          onClose();
        }, 1000);
      } else {
        const errorMessage =
          smsResp?.data?.StatusMessage ??
          smsResp?.data?.message ??
          "An unexpected error occurred. Please try again.";

        setSnackbar({
          open: true,
          severity: "error",
          message: errorMessage,
        });
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.StatusMessage ??
        error.response?.data?.message ??
        error.message ??
        "An unexpected error occurred. Please try again.";

      setSnackbar({
        open: true,
        severity: "error",
        message: errorMessage,
      });
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} style={{ width: "auto" }}>
      <AlertComponent
        open={snackbar.open}
        handleSnackbar={handleSnackbarClose}
        severity={{ severity: snackbar.severity, message: snackbar.message }}
      />

      <FormControl
        fullWidth
        sx={{
          mt: "20px",
        }}
        error={!!errors.message}
      >
        <InputLabel htmlFor="message">Message</InputLabel>
        <OutlinedInput
          fullWidth
          id="message"
          type="text"
          label={`message`}
          {...register("message")}
          multiline
          minRows={4}
          maxRows={10}
        />
        <FormHelperText>Input message to send to member!</FormHelperText>
        {errors.amount && <FormHelperText>Enter loan amount!</FormHelperText>}
      </FormControl>

      <Box
        sx={{
          gap: 2,
          pt: "40px",
          display: "flex",
          direction: "row",
          justifyContent: "flex-end",
        }}
      >
        <Button variant="outlined" type="reset" onClick={() => onClose()}>
          Cancel
        </Button>
        <LoadingButton variant="contained" type="submit" loading={loading}>
          Submit
        </LoadingButton>
      </Box>
    </form>
  );
};

export default UserSmsForm;
